import { Typography } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const DATE_FORMAT = 'YYYY.MM.DD HH:mm';

interface LastSavedIndicatorProps {
  date?: string;
}
export default function LastSavedIndicator({ date }: LastSavedIndicatorProps) {
  const { t } = useTranslation();
  return (
    <Typography
      sx={{
        mr: 1,
        fontSize: '12px',
        color: theme => theme.palette.action.disabled,
      }}
    >
      {t('forms.lastSaved', {
        date: moment(date).format(DATE_FORMAT),
      })}
    </Typography>
  );
}
